import React from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import "../../style/custom/terms-and-service.scss";
import Modal from "../bootstrap/modal";

export default function TermModal(props) {
  const { onClose } = props;

  return (
    <Modal
      title={"Privacy Policy"}
      onClose={onClose}
      show
      footer={
        <Row>
          <Col xs="auto" className="ml-auto"></Col>
          <Col xs="auto">
            <Button  className="terms-close" type="button" onClick={() => onClose()}>
              {"Close"}
            </Button>
          </Col>
        </Row>
      }
    >
      <Container fluid>
        <Row>
          <Col>
          <a target="_blank" 
            href="https://files.superloop.com/terms/SL-Residential-privacy-policy.pdf"
          >
            Click Here for Privacy Policy
          </a>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}
